import { type FC } from 'react';
import { Tooltip, type TooltipDirection } from 'dibs-elements/exports/Tooltip.tsx';
import { FormattedMessage } from 'dibs-react-intl';

type Props = {
    isTooltipVisible: boolean;
    onClose: () => void;
    tooltipDirection?: TooltipDirection;
};

const PhotoLikeFeedbackTooltip: FC<Props> = ({
    onClose,
    isTooltipVisible,
    tooltipDirection = 'top',
}) => {
    return (
        <Tooltip
            isVisible={isTooltipVisible}
            direction={tooltipDirection}
            type="small"
            paddingSize="xSmall"
            closeOnOutsideClick
            onClose={onClose}
        >
            <FormattedMessage
                defaultMessage="Photo saved to your Favorites"
                id="dip.photoLiking.photoLikeFeedbackTooltip.saved"
            />
        </Tooltip>
    );
};

export default PhotoLikeFeedbackTooltip;
